import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import SherlockIcon from '../Icon/Sherlock'
import Tooltip from '@components/Tooltip'
import './SherlockReason.sass'

// eslint-disable-next-line camelcase
function getMessage({ allowed, reason, display_reason } = {}) {
  if (reason?.type === 'email') {
    return `Sherlock believes expert has an email in the Blocklist: ${reason.value}`
  } else if (reason?.type === 'company_name') {
    return `Sherlock believes expert is working for a Blocklist company: ${reason.value}`
  } else {
    // eslint-disable-next-line camelcase
    return display_reason
  }
}

const renderChip = (sherlock, iconOnly) => {
  let boxColor = sherlock.reason ? '#FF5858' : '#39AC57'
  if (sherlock.reason && sherlock.reason.type === 'error') {
    boxColor = '#FCE5C8'
  }

  const style = { backgroundColor: boxColor }

  if (sherlock && !sherlock.allowed && iconOnly) {
    style.display = 'inline-flex'
    style.borderRadius = 30
    style.width = 17
    style.height = 17
    style.marginLeft = 3
    style.marginRight = 3
    style.padding = 1
    style.alignItems = 'center'
    style.justifyContent = 'center'

    document.querySelectorAll('.sherlock-reason .icon svg').forEach($el => {
      $el.setAttribute('style', 'height: 11px !important')
    })
  }

  return (
    <div className="sherlock-reason" style={style}>
      <SherlockIcon
        fill="#FFFFFF"
        width={iconOnly ? 11 : 16}
        height={iconOnly ? 11 : 16}
        style={{
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      />
      {!iconOnly && <div className="m-l-md">Sherlock Warning!</div>}
    </div>
  )
}

const SherlockReason = ({ sherlock, iconOnly }) => {
  useEffect(() => {
    if (iconOnly) {
      document.querySelectorAll('.sherlock-reason .icon svg').forEach($el => {
        $el.setAttribute('style', 'height: 15px !important')
      })
    }
  })

  const tooltip = getMessage(sherlock)

  if (!sherlock || sherlock.allowed || !tooltip) {
    return null
  }

  return (
    <Tooltip sherlock tooltip={tooltip}>
      {renderChip(sherlock, iconOnly)}
    </Tooltip>
  )
}

SherlockReason.propTypes = {
  sherlock: PropTypes.object,
  iconOnly: PropTypes.bool
}

export default SherlockReason
